import React from "react";

const NotFoundPage = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "8rem",
        fontWeight: "bold",
        color: "#FFFFFF",
        height: "80%",
      }}
    >
      404
    </div>
  );
};

export default NotFoundPage;
